import calendar from './calendar.json';
import clinics from './clinics.json';
import communityBoard from './community-board.json';
import dentists from './dentists.json';
import forgotPassword from './forgot-password.json';
import general from './general.json';
import home from './home.json';
import labOrders from './lab-orders.json';
import labs from './labs.json';
import login from './login.json';
import messages from './messages.json';
import myClinics from './my-clinics.json';
import navigation from './navigation.json';
import notificationSettings from './notification-settings.json';
import onboarding from './onboarding.json';
import packagesPricing from './packages-pricing.json';
import plansPayments from './plans-payments.json';
import profile from './profile.json';
import referrals from './referrals.json';
import registration from './registration.json';
import topCustomers from './top-customers.json';
import topDentists from './top-dentist.json';
import tutorials from './tutorials.json';
import verification from './verification.json';

export default {
  calendar,
  forgotPassword,
  general,
  login,
  navigation,
  onboarding,
  registration,
  verification,
  home,
  topDentists,
  referrals,
  dentists,
  labs,
  clinics,
  topCustomers,
  labOrders,
  messages,
  profile,
  myClinics,
  plansPayments,
  packagesPricing,
  communityBoard,
  notificationSettings,
  tutorials,
};
